import Toast, { ToastProps } from "./Toast";
import { modalService } from "@whatslly/ui-components/modals";

const toaster = {
  triggerToast(toast: ToastProps) {
    return modalService.openModal(Toast, toast);
  },
};

/**
 *
 * @deprecated use modalService.openModal(Toast, toast) instead
 */
export const useToast = () => {
  return toaster;
};
